export default __webpack_public_path__ + "static/media/guest2.bf941523.jpg";